// Müşteri Ekranı Yönetimi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.poleDisplay';

export const salesPoleDisplayGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Müşteri Ekranı Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Müşteri ekranı, siparişlerin hazırlanma durumunu müşterilere gösteren ekrandır (ör. kasanın arkasındaki TV). Her QR menü için bir müşteri ekranı vardır; buradan kimin açabileceğini belirler ve ekranı açarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    table: t(`${G}.regions.table`, 'Menüler (ekranlar)'),
  },
  steps: [
    {
      region: 'table',
      title: t(`${G}.s1.title`, '1. Ekranı seçin'),
      text: t(`${G}.s1.text`, 'Listede tanımlı QR menüleriniz "Menü Adı" ve "Şube" ile görünür; her satır bir müşteri ekranıdır. Liste boşsa ("Menü Bulunamadı") önce QR menü tanımlamanız gerekir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Ekranın şubesi, bağlı olduğu QR menünün şubesidir. Menüye şube atanmamışsa "Şube Atanmamış" yazar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Personel yetkilerini verin'),
      text: t(`${G}.s2.text`, 'Satırdaki ayar (dişli) düğmesi "Personel Yetkileri" penceresini açar. "Erişim" işaretli personel bu müşteri ekranını açabilir. "Otomatik Aç" işaretliyse o personel giriş yaptığında doğrudan bu ekrana yönlendirilir. "Kaydet" ile saklayın.'),
      tips: [
        t(`${G}.s2.tip1`, '"Otomatik Aç" yalnız "Erişim" işaretliyken seçilebilir.'),
        t(`${G}.s2.tip2`, 'Girişte otomatik yönlendirme Personel ve Kurye rolündeki kullanıcılarda çalışır. Ekranın bulunduğu cihaz için ayrı bir personel kullanıcısı açıp ona "Erişim" ve "Otomatik Aç" vermek pratiktir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Müşteri ekranını açın'),
      text: t(`${G}.s3.text`, 'Satırdaki göz düğmesi ("Müşteri Ekranını Aç") ekranı yeni bir sekmede açar. Bu sekmeyi müşterilerin göreceği monitöre taşıyıp tam ekran yapın.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Ekranda ne görünür?'),
      text: t(`${G}.s4.text`, 'Ekran iki bölümdür: "HAZIRLANIYOR" bölümünde bekleyen ve hazırlanan siparişlerin kodları, "HAZIR" bölümünde hazır siparişlerin kodları ve bekleme süreleri yer alır. Yeni sipariş geldiğinde "YENİ SİPARİŞ", mutfakta bir sipariş "Hazır" yapıldığında "SİPARİŞ HAZIRLANDI" bildirimi sipariş koduyla birlikte 2 saniye büyük olarak gösterilir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Teslim edilen ve iptal edilen siparişler ekrandan kalkar. Sipariş durumları Mutfak Ekranından güncellenir.'),
        t(`${G}.s4.tip2`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
